<template>
  <el-form-item :label="i18nt('designer.setting.defaultValue')">
    <el-date-picker type="date" v-model="defaultValue" @change="defaultValueChanged" :format="optionModel.format" :value-format="valueFormat" style="width: 100%"> </el-date-picker>
  </el-form-item>
</template>

<script>
import { toRefs, reactive, watch } from 'vue';

import { useI18n } from '@/utils/i18n';
import { useProperty } from '@/components/form-designer/setting-panel/property-editor/propertyMixin';

import { parseTime } from '@/utils/date-util';
export default {
  name: 'm-calendar-defaultValue-editor',
  props: {
    designer: Object,
    optionModel: Object,
    selectedWidget: Object,
  },
  setup(props) {
    const { i18nt } = useI18n();
    const propertyMixin = useProperty();

    const data = reactive({
      defaultValue: props.optionModel.defaultValue,
      valueFormat: 'YYYY-MM-DD',
    });

    const defaultValueChanged = val => {
      if (val) {
        props.optionModel.defaultValue = parseTime(val, data.valueFormat).format(props.optionModel.format);
      } else {
        props.optionModel.defaultValue = null;
      }
      propertyMixin.emitDefaultValueChange();
    };

    watch(
      () => props.optionModel.format,
      newFomart => {
        if (!data.defaultValue) return;

        defaultValueChanged(data.defaultValue);
      }
    );

    watch(
      () => props.optionModel.defaultValue,
      newFomart => {
        data.defaultValue = props.optionModel.defaultValue;
      }
    );

    return {
      i18nt,
      ...toRefs(props),
      ...toRefs(data),
      ...propertyMixin,
      defaultValueChanged,
    };
  },
};
</script>

<style scoped></style>
